import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as constants from 'redux/constants/app.constants';
import * as cartConstants from 'redux/constants/cart.constants';
import {
  getMinimumPurchase, getAllSliders, getWhatsapp, getDiscount, getCatalogs, getPrices, getInstagram,
  getDataAnalytics, getshowMPButton, getTransferInfo,getEnvios, getInitialData,
} from 'services/app.services';
import { categoryGetAll, cartelHomeGet, categoryHomeGet, marcasHomeGet } from './category.sagas';
import { productGetMaxPrice, productGetOffers, productGetNewArrivals, productGetMostSelled } from './product.sagas';
import { userProfile } from './user.sagas';
import { subCategoryGetAll, subCategoryHomeGet } from './subCategory.sagas';

export function* loadInitialData() {
  try {
    const data = yield call(getInitialData);
    yield all([
      call(safeCall, minimumPurchaseGet, data.minimumAmount.original),
      call(safeCall, slidersGetAll, data.sliders.original),
      call(safeCall, enviosGet, data.envios.original),
      call(safeCall, whatsappGet, data.whatsapp.original),
      call(safeCall, catalogsGet, data.catalogs.original),
      call(safeCall, pricesGet, data.prices.original),
      call(safeCall, dataAnalyticsGet, data.dataAnalytics.original),
      // call(safeCall, discountGet, data.discounts.original),
      call(safeCall, instagramGet, data.instagram.original),

      call(safeCall, categoryGetAll, data.categories.original),
      call(safeCall, categoryHomeGet, data.categoriesHome.original),
      call(safeCall, marcasHomeGet, data.marcasHome.original),
      call(safeCall, cartelHomeGet, data.cartelHome.original),

      call(safeCall, subCategoryGetAll, data.subcategories.original),
      call(safeCall, subCategoryHomeGet, data.subcategoriesHome.original),

      call(safeCall, productGetMaxPrice, data.maxPrice.original),
      call(safeCall, productGetMostSelled, data.mostSelled.original),
      call(safeCall, productGetNewArrivals, data.newArrivals.original),
      call(safeCall, productGetOffers, data.offers.original),
      call(safeCall, cuotasMPGet, data.cuotasMP),

      call(safeCall, userProfile, data.profile.original),
    ]);
  } catch (error) {
    console.log("error:" ,error);
    const errorMessage = "Disculpe las molestias, estamos trabajando para restablecer la web. Pruebe en breve o comuníquese por WhatsApp. \n Gracias.";
    yield put({type: constants.APP_INITIALIZE_FAILED, data : errorMessage});
  }
}

export function* safeCall(fn, ...args) {
  try {
    yield call(fn, ...args);
  } catch (error) {
    console.error(`Error en ${fn.name}:`, error);
  }
}

export function* minimumPurchaseGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const minimumAmount = !isReduxAction && data ? data :yield call(getMinimumPurchase);
    yield put({ type: constants.APP_MINIMUM_PURCHASE_SUCCEEDED, data : minimumAmount });
  } catch (error) {
    yield put({ type: constants.APP_MINIMUM_PURCHASE_FAILED, error });
  }
}
export function* discountGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const discount = !isReduxAction && data ? data : yield call(getDiscount);
    console.log("discountGet", discount);
    yield put({ type: constants.APP_DISCOUNT_SUCCEEDED, data : discount });
  } catch (error) {
    yield put({ type: constants.APP_DISCOUNT_FAILED, error });
  }
}

export function* slidersGetAll(data = null) {
  try {
    const isReduxAction = data && data.type;
    const sliders = !isReduxAction && data ? data : yield call(getAllSliders);
    yield put({ type: constants.APP_SLIDERS_GET_ALL_SUCCEEDED, data : sliders });
  } catch (error) {
    yield put({ type: constants.APP_SLIDERS_GET_ALL_FAILED, error });
  }
}

export function* whatsappGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const whatsapp = !isReduxAction && data ? data : yield call(getWhatsapp);
    yield put({ type: constants.APP_WHATSAPP_SUCCEEDED, data : whatsapp });
  } catch (error) {
    yield put({ type: constants.APP_WHATSAPP_FAILED, error });
  }
}

export function* instagramGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const instagram = !isReduxAction && data ? data : yield call(getInstagram);
    yield put({ type: constants.APP_INSTAGRAM_SUCCEEDED, data : instagram });
  } catch (error) {
    yield put({ type: constants.APP_INSTAGRAM_FAILED, error });
  }
}

export function* catalogsGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const catalogs = !isReduxAction && data ? data : yield call(getCatalogs);
    yield put({ type: constants.APP_CATALOGS_SUCCEEDED, data : catalogs });
  } catch (error) {
    yield put({ type: constants.APP_CATALOGS_FAILED, error });
  }
}

export function* pricesGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const prices = !isReduxAction && data ? data : yield call(getPrices);
    yield put({ type: constants.APP_PRICES_SUCCEEDED, data : prices });
  } catch (error) {
    yield put({ type: constants.APP_PRICES_FAILED, error });
  }
}

export function* dataAnalyticsGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const dataAnalytics = !isReduxAction && data ? data :yield call(getDataAnalytics);
    yield put({ type: constants.APP_DATA_ANALYTICS_SUCCEEDED, data : dataAnalytics });
  } catch (error) {
    yield put({ type: constants.APP_DATA_ANALYTICS_FAILED, error });
  }
}

export function* showMPButtonGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const showMPButton = !isReduxAction && data ? data :yield call(getshowMPButton);
    yield put({ type: constants.APP_MP_BUTTON_SUCCEEDED, data : showMPButton });
  } catch (error) {
    yield put({ type: constants.APP_MP_BUTTON_FAILED, error });
  }
}

export function* transferInfoGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const transferInfo = !isReduxAction && data ? data : yield call(getTransferInfo);
    yield put({ type: constants.APP_TRANSFER_INFO_SUCCEEDED, data : transferInfo });
  } catch (error) {
    yield put({ type: constants.APP_TRANSFER_INFO_FAILED, error });
  }
}

export function* enviosGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const envios = !isReduxAction && data ? data : yield call(getEnvios);
    yield put({ type: constants.APP_ENVIOS_SUCCEEDED, data : envios });
  } catch (error) {
    yield put({ type: constants.APP_ENVIOS_FAILED, error });
  }
}

export function* cuotasMPGet(data = null) {
  try {
    const cuotasMP = data;
    yield put({ type: constants.APP_CUOTASMP_SUCCEEDED, data : cuotasMP });
  } catch (error) {
    yield put({ type: constants.APP_CUOTASMP_FAILED, error });
  }
}

export function* watchApp() {
  yield all([
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, minimumPurchaseGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, slidersGetAll),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, enviosGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, whatsappGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, instagramGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, catalogsGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, pricesGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, dataAnalyticsGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, showMPButtonGet),
    // takeLatest(constants.APP_INITIALIZE_REQUESTED, transferInfoGet),
    takeLatest(constants.APP_INITIALIZE_REQUESTED, loadInitialData),
    takeLatest(cartConstants.CART_CHECKOUT_SUCCEEDED, loadInitialData),
  ]);
}
